import PropTypes from 'prop-types';
import * as React from 'react';

import stylesFilterNode from './FilterNode.less';
import FilterNodeTypeBoolItem from './FilterNodeTypeBoolItem';
import {FilterNodeTypeWrapper} from './FilterNodeTypeWrapper';
import {DynamicFilter, Filter, FILTER_TYPE_BOOL} from 'src/js/lib/filtering';
import {
  FilterSchema,
  FilterNode as FilterNodeModel,
} from 'src/js/model/filters_config';

class FilterNodeTypeBool extends React.PureComponent {
  getFilter() {
    const {node} = this.props;
    const BoolFilter = DynamicFilter.getFilterClass(FILTER_TYPE_BOOL);
    return new BoolFilter({
      type: FILTER_TYPE_BOOL,
      property: node.getName(),
      value: '',
    });
  }

  render() {
    const {
      changeFilter,
      isFilterSelected,
      isOpened,
      node,
      toggleOpened,
      removeFilter,
      schema,
      selectedFilter,
      setFocus,
    } = this.props;
    const filter = this.getFilter();

    return (
      <FilterNodeTypeWrapper
        filter={filter}
        isOpened={isOpened}
        node={node}
        removeFilter={removeFilter}
        setFocus={setFocus}
        selectedFilter={selectedFilter}
        toggleOpened={toggleOpened}
      >
        {node.getChildrenIds().map((filterId) => (
          <ul className={stylesFilterNode.dlIndentedList} key={filterId}>
            <FilterNodeTypeBoolItem
              node={schema.getFilter(filterId)}
              parentName={node.getName()}
              selectedFilter={selectedFilter}
              isFilterSelected={isFilterSelected}
              isOpened={isOpened}
              changeFilter={changeFilter}
              removeFilter={removeFilter}
            />
          </ul>
        ))}
      </FilterNodeTypeWrapper>
    );
  }
}

FilterNodeTypeBool.displayName = 'FilterNodeTypeBool';

FilterNodeTypeBool.propTypes = {
  node: PropTypes.instanceOf(FilterNodeModel).isRequired,
  changeFilter: PropTypes.func.isRequired,
  isFilterSelected: PropTypes.func,
  isOpened: PropTypes.bool,
  removeFilter: PropTypes.func.isRequired,
  schema: PropTypes.instanceOf(FilterSchema).isRequired,
  selectedFilter: PropTypes.instanceOf(Filter),
  setFocus: PropTypes.func.isRequired,
  toggleOpened: PropTypes.func.isRequired,
};

FilterNodeTypeBool.defaultProps = {
  isFilterSelected: undefined,
  isOpened: false,
  selectedFilter: undefined,
};

FilterNodeTypeBool.defaultProps = {
  isOpened: false,
};

export default FilterNodeTypeBool;
